import { defineStore } from 'pinia'

export const useCacheStore = defineStore('cache', {
  state: () => ({
    cachedPages: []
  }),

  actions: {
    // 添加页面到缓存
    addToCache(pageName) {
      if (pageName && !this.cachedPages.includes(pageName)) {
        this.cachedPages.push(pageName)
      }
    },

    // 从缓存移除页面
    removeFromCache(pageName) {
      if (pageName) {
        const index = this.cachedPages.indexOf(pageName)
        if (index > -1) {
          this.cachedPages.splice(index, 1)
        }
      }
    },

    // 获取缓存列表
    getCachedPages() {
      return this.cachedPages
    },

    // 处理路由跳转的缓存逻辑
    handleRouteChange(to, from) {
      if (!from) return

      // 从需要缓存的路由离开
      if (from.meta?.keepAlive && from.meta.keepAliveToRouteNames) {
        const shouldKeepAlive = from.meta.keepAliveToRouteNames.includes(to.name)

        if (shouldKeepAlive) {
          this.addToCache(from.name)
        } else {
          this.removeFromCache(from.name)
        }
      }

      // 当前页面如果需要缓存
      if (to.meta?.keepAlive && to.name) {
        this.addToCache(to.name)
      } else if (to.name) {
        // 如果当前页面不需要缓存，确保它不在缓存列表中
        this.removeFromCache(to.name)
      }
    }
  }
})

export default useCacheStore
